import type { LayerParamValue } from '@growtherapy/analytics';

export type IntakeSummaryExperimentStatus = 'loading' | 'ready' | 'error';
export type IntakeSummaryExperimentExperience = 'control' | 'treatment';

export interface ResolveIntakeSummaryExperienceInput {
  status: IntakeSummaryExperimentStatus;
  cutoverAt: Date | null;
  now: Date;
  /** Live Statsig layer parameter value for shouldShowIntakeSummary. */
  liveAllocationValue: LayerParamValue | undefined;
}

function isTreatmentAllocationValue(value: LayerParamValue | undefined): boolean {
  return value === 'true' || value === true;
}

/**
 * Resolves intake summary experiment experience after cutover.
 *
 * Pre-cutover always returns control. Post-cutover treatment follows live Statsig
 * so GA/ship and rollback are controlled by the layer parameter alone.
 */
export function resolveIntakeSummaryExperience({
  status,
  cutoverAt,
  now,
  liveAllocationValue,
}: ResolveIntakeSummaryExperienceInput): IntakeSummaryExperimentExperience {
  if (status !== 'ready') {
    return 'control';
  }

  if (!cutoverAt || now.getTime() < cutoverAt.getTime()) {
    return 'control';
  }

  if (isTreatmentAllocationValue(liveAllocationValue)) {
    return 'treatment';
  }

  return 'control';
}
